import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "./app/index.css";
import App from "./app/App";
import { Amplify } from "aws-amplify";
import { clearLegacyServiceWorkers } from "./shared/utils/clearLegacyServiceWorkers";

clearLegacyServiceWorkers();

Amplify.configure({
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
